<template>
  <div>
    <!-- <b-button size="sm" variant="primary" @click="$bvModal.show(modalId)" :disabled="partId == 0"> Create Inventory </b-button> -->
    <b-modal id="inventory-form-modal" :ref="modalId" no-close-on-backdrop>
      <template slot="modal-header">
        <h5 class="modal-title">Creating Inventory Record</h5>
      </template>
      <b-row>
        <b-col cols="4">
          <b-form-group label="Company" class="required">
            <vue-simple-suggest
              class="suggest-input form-control"
              :styles="autoCompleteStyle"
              :list="getListOfNames"
              :max-suggestions="20"
              :min-length="3"
              :debounce="200"
              :filter-by-query="true"
              value-attribute="id"
              display-attribute="name"
              v-model="companyNameSelected"
              @select="onSuggestNameSelect"
              @input="onSuggestNameChange"
              @blur="onCompanyBlur"
              @request-done="onRequestDone"
            >
              <div
                slot="misc-item-below"
                v-if="isLoadingCompany"
                class="misc-item"
              >
                <span>Loading companies...</span>
              </div>
            </vue-simple-suggest>
          </b-form-group>
        </b-col>
        <b-col cols="3">
          <b-form-group label="Contact">
            <b-form-select v-model="formObj.contactId">
              <option
                v-for="(select, index) in sortSelect(contacts,'firstName')"
                :key="index"
                :value="select.id"
                >{{ select.firstName + ' ' + select.lastName }}</option
              >
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
      <table>
        <tr>
          <th>Quantity <span class="required-field">*</span></th>
          <th>{{ (formObj.isSplit) ? 'Repack' : 'Cost'}} <span v-if="!formObj.isSplit" class="required-field">*</span></th>
          <th>{{ (formObj.isSplit) ? '' : 'Date Code'}}</th>
          <th>{{ (formObj.isSplit) ? '' : 'Lot'}}</th>
          <th>{{ (formObj.isSplit) ? '' : 'Revision'}}</th>
          <th>{{ (formObj.isSplit) ? '' : 'Condition'}} <span v-if="!formObj.isSplit" class="required-field">*</span></th>
          <th>{{ (formObj.isSplit) ? '' : 'COO'}} <span v-if="!formObj.isSplit" class="required-field">*</span></th>
          <th>Comment</th>
          <th></th>
          <th></th>
          <th>Warehouse  <span class="required-field">*</span></th>
          <th>Location  <span class="required-field">*</span></th>
        </tr>
        <tr>
          <td>
            <b-input-group>
                <template v-slot:append>
                  <b-button :variant="(formObj.isSplit) ? 'primary' : 'outline-primary'" @click="splitChange">
                    <!-- <i class="fa fa-share-square"></i> -->
                    Split
                  </b-button>
                </template>
                <input :min="0" placeholder="0" type="number" class="form-control max-number-width" v-model.number="formObj.quantity" />
            </b-input-group>
          </td>
          <td>
            <input :min="0" placeholder="0" type="number" class="form-control max-number-width" v-model.number="formObj.cost" v-if="!formObj.isSplit" />
            <b-form-checkbox v-model="formObj.repack" v-else />
          </td>
          <td>
            <input v-model="formObj.dateCode" class="form-control" v-if="!formObj.isSplit" style="width: 100px;" />
          </td>
          <td>
            <input v-model="formObj.lotCode" class="form-control" v-if="!formObj.isSplit" style="width: 80px;" />
          </td>
          <td>
            <input v-model="formObj.revision" class="form-control" v-if="!formObj.isSplit" style="width: 100px;" />
          </td>
          <td>
            <b-form-select v-model="formObj.conditionId" class="form-control" v-if="!formObj.isSplit" style="width:180px" >
              <option v-for="condition in conditions" :key="condition.id" :value="condition.id">
                {{ condition.name }}
              </option>
            </b-form-select>
          </td>
          <td>
            <b-form-select v-model="formObj.countryOfOriginId" style="width:200px" v-if="!formObj.isSplit">
              <option v-for="countryCode in countryCodes" :key="countryCode.id" :value="countryCode.id">
                {{ countryCode.name }}
              </option>
            </b-form-select>
          </td>
          <td>
            <input v-model="formObj.comments" class="form-control" />
          </td>
          <td>
            <b-button class="form-control" v-b-modal="'serial-num-modal'" v-if="!formObj.isSplit">S/N</b-button>
            <b-modal
              size="lg"
              :id="'serial-num-modal'"
              :ref="'serial-num-modal'"
              ok-title="Save">
              <template slot="modal-header">
                <h5 class="modal-title">Serial Numbers</h5>
              </template>
              <b-textarea v-model="formObj.serialNumbers"></b-textarea>
            </b-modal>
          </td>
          <td>
            <b-button class="form-control" v-if="!formObj.isSplit" v-b-modal="'upload-image-modal'"><i class="fa fa-image" /></b-button>
            <b-modal :id="'upload-image-modal'" :ref="'upload-image-modal'" size="sm" :title="'Upload Image'">
                <b-form-file multiple v-model="formObj.images" :file-name-formatter="formatNames" :accept="fileTypes"></b-form-file>
            </b-modal>
          </td>
          <td>
            <b-form-select v-model="formObj.warehouseId" style="max-width:150px">
                <option v-for="warehouse in warehouses" :key="warehouse.id" :value="warehouse.id">
                  {{ warehouse.name }}
                </option>
            </b-form-select>
          </td>
          <td>
            <input v-model="formObj.location" class="form-control" />
          </td>
        </tr>
        <tr v-if="formObj.isSplit">
          <th></th>
          <th>Quantity</th>
          <th></th>
          <th>Cost</th>
          <th>Date Code</th>
          <th>Lot</th>
          <th>Revision</th>
          <th>Condition</th>
          <th>COO</th>
          <th>Split Comment</th>
          <th></th>
          <th></th>
          <th></th>
        </tr>
        <split-details
          v-for="(splitObj, i) in formObj.inventorySplits"
          :key="i" :ndx="i"
          :isSplit="formObj.isSplit"
          :splitObj="splitObj"
          @onSplitQuantityChange="onSplitQuantityChange($event, i)"
        />
        
      </table>
      <template slot="modal-footer">
        <b-button @click="$bvModal.hide(modalId)">Cancel</b-button>
        <b-button variant="primary" @click="saveInventory" :disabled="isCreating">Create Part Inventory</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import VueSimpleSuggest from 'vue-simple-suggest';
import SplitDetails from './splitDetails';
import {AUTO_COMPLETE_STYLES} from '@/shared/constants';

export default {
  components: {
    VueSimpleSuggest,
    SplitDetails
  },
  props: {
    partId: {
      type: [Number, String],
      default: 0
    }
  },
  data() {
    return {
      modalId: 'inventory-form-modal',
      formObj: {
        companyId: 0,
        contactId: 0,
        quantity: 0,
        cost: 0,
				dateCode: null,
				lotCode: null,
				revision: null,
				conditionId: 0,
        countryOfOriginId: 0,
        warehouseId: 0,
        location: null,
        comments: null,
        images: null,
        isSplit: false,
        inventorySplits: []
      },
      fileTypes: [
        '.png',
        '.jpg',
        '.jpeg',
        '.gif'
      ].join(', '),
      isCreating: false,
      autoCompleteStyle: AUTO_COMPLETE_STYLES,
      companyList: [],
      companyNameSelected: null,
      isLoadingCompany: false
    }
  },
  computed: {
    ...mapGetters('lookup', [ 'conditions', 'countryCodes', 'warehouses' ]),
    ...mapGetters('quoteAdd', ['contacts']),
    sumSplitQuantity() {
      if (this.formObj.inventorySplits.length > 0)
        return this.formObj.inventorySplits.map(details => details.quantity).reduce((a, b) => a + b);
      else 
        return 0;
    }
  },
  methods: {
    ...mapActions('inventory', ['createPartInventory']),
    ...mapActions('companies', ['getByNameAndAccountType']),
    ...mapActions('quoteAdd', ['getContacts', 'clearContacts']),
    initializeFields() {
      this.companyNameSelected = null;
      this.formObj = {
        companyId: 0,
        contactId: 0,
        quantity: 0,
        cost: 0,
				dateCode: null,
				lotCode: null,
				revision: null,
				conditionId: 0,
        countryOfOriginId: 0,
        warehouseId: 0,
        location: null,
        comments: null,
        images: null,
        isSplit: false,
        inventorySplits: []
      }
    },
    splitChange() {
      this.formObj.isSplit = !this.formObj.isSplit;

      if (this.formObj.isSplit) {
        this.formObj.inventorySplits.push(this.readyMadeReceiveDetailObj());
      } else {
        this.formObj.inventorySplits = [];
      }
    },
    onSplitQuantityChange(val, splitIndex) {
      let quantity = this.formObj.quantity;
      let lastIndexVal = this.formObj.inventorySplits.length -1;

			if (val.newVal > quantity || this.sumSplitQuantity > quantity) {
				this.formObj.inventorySplits[splitIndex].quantity = val.oldVal;
			}

			if (this.sumSplitQuantity < quantity && this.formObj.inventorySplits[lastIndexVal].quantity > 0) {
				this.formObj.inventorySplits.push(this.readyMadeReceiveDetailObj());
			} else if (this.sumSplitQuantity === quantity && this.formObj.inventorySplits[lastIndexVal].quantity == 0) {
				this.formObj.inventorySplits.pop();
			} else if (val.newVal == 0 && this.formObj.inventorySplits[lastIndexVal].quantity == null && this.formObj.inventorySplits.length != 1) {
				this.formObj.inventorySplits.pop();
			}
    },
    readyMadeReceiveDetailObj() {
			return {
				quantity: 0,
        cost: 0,
				dateCode: null,
				lotCode: null,
				revision: null,
				conditionId: 0,
        countryOfOriginId: 0,
        warehouseId: 0,
        location: null,
        comments: null,
        images: null
			};
    },
    formatNames(files) {
      if (files.length === 1) {
        return files[0].name;
      } else {
        return `${files.length} files selected`;
      }
    },
    isValidObj() {
      let isValid = this.formObj.companyId > 0
          && this.formObj.quantity != ""
					&& this.formObj.cost != ""
					&& this.formObj.conditionId != null
					&& this.formObj.countryOfOriginId != null
					&& this.formObj.warehouseId != null
          && this.formObj.location != null

      for (let i = 0; i < this.formObj.inventorySplits.length; i++) {
        isValid = this.formObj.inventorySplits[i].quantity != null
					&& this.formObj.inventorySplits[i].cost != null
					&& this.formObj.inventorySplits[i].conditionId != null
					&& this.formObj.inventorySplits[i].countryOfOriginId != null
					&& this.formObj.inventorySplits[i].warehouseId != null
          && this.formObj.inventorySplits[i].location != null
      }
          
      return isValid;
    },

    async saveInventory() {
      if (!this.isValidObj()) {
				alert("Please populate required fields.");
				return;
			}

      this.isCreating = true;
      const dto = { ...this.formObj, partId: this.partId };

      await this.createPartInventory(dto).then((res) => {
        if (res.status == 200) {
          this.isCreating = false;
          this.$bvModal.hide(this.modalId);
          this.$snotify.success('Created inventory for part');
          this.$emit('part-inventory-success');
          this.initializeFields();
        }
      })
    },
    async getListOfNames(name) {
      this.companyList = await this.getByNameAndAccountType({
        typeId: 0, name});

      return this.companyList;
    },
    async onSuggestNameSelect(suggestion) {
      this.formObj.companyId = suggestion.id;
      this.companyNameSelected = suggestion.name
      this.getContacts(suggestion.id);
    },
    async onSuggestNameChange(val) {
      this.isLoadingCompany = true;
      if(val === '') {
        this.companyNameSelected = null;
        this.formObj.companyId = 0;
        this.formObj.contactId = 0;
        this.clearContacts();
      }
    },
    onCompanyBlur() {
      if(this.companyNameSelected) {
        if (this.companyList.length > 0) {
          const findIndex = this.companyList.findIndex(x => this.companyNameSelected.toLowerCase() == x.name.toLowerCase());

          if (findIndex > -1) {
            this.onSuggestNameSelect(this.companyList[findIndex]);
          }
        }
      }
    },
    onRequestDone() {
      this.isLoadingCompany = false;
    },
  }
}
</script>


<style scoped>
  .split {
    font-size: 10px;
  }
  .max-number-width {
    width: 80px;
  }

  table {
    margin-top: 15px;
    border-top-style: double;
  }

  td {
    padding-left: 8px;
  }

  th {
    padding-left: 8px;
  }

  .highlight-text-field {
    background-color: #ffc107
  }

  .required-field {
    color: red
  }
</style>

<style>
#inventory-form-modal .modal-dialog {
    max-width: 1520px !important;
  }
</style>